module.exports = __webpack_public_path__ + "omniv2/img/info.54091610.svg";